import React, { Component } from 'react';

import PropTypes from 'prop-types';

import TableContainer from './TableContainer';


class CRUD extends Component {
	render() {
		return (
			<div>
				<TableContainer {...this.props} />
			</div>
		);
	}
}

CRUD.propTypes = {
	schema: PropTypes.object.isRequired,
	tableCustomId: PropTypes.string,
	buttonCustomId: PropTypes.string,
	actionCustomId: PropTypes.string,
	customCreate: PropTypes.any,
	customUpdate: PropTypes.any,
	customDelete: PropTypes.any,
  customAction: PropTypes.any,
	customExport: PropTypes.any,
	customPathname: PropTypes.string,
	moduleQuery: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.object),
		PropTypes.object
	]),
	saveTrail: PropTypes.func,
	access: PropTypes.arrayOf(PropTypes.object),
	showButtonActionAsText: PropTypes.bool
};

export default CRUD;



// WEBPACK FOOTER //
// ./components/zynappse-crud/index.js